import listeningIcon from "assets/img/activities/listening.png"
import readingIcon from "assets/img/activities/reading.png"
import speakingIcon from "assets/img/activities/speaking.png"
import writingIcon from "assets/img/activities/writing.png"
import checkIcon from "assets/img/activities/icn_right.svg"
import wrongIcon from "assets/img/activities/icn_wrong.svg"
import correctAnswer from "assets/img/activities/check.png"
import wrongAnswer from "assets/img/activities/cross.png"
import ahogado01 from "assets/img/activities/Ahogado01.png"
import ahogado02 from "assets/img/activities/Ahogado02.png"
import ahogado03 from "assets/img/activities/Ahogado03.png"
import ahogado04 from "assets/img/activities/Ahogado04.png"
import ahogado05 from "assets/img/activities/Ahogado05.png"
import ahogadoSmashy00 from "assets/img/activities/AhogadoSmashy00.jpg"
import ahogadoSmashy01 from "assets/img/activities/AhogadoSmashy01.jpg"
import ahogadoSmashy02 from "assets/img/activities/AhogadoSmashy02.jpg"
import ahogadoSmashy03 from "assets/img/activities/AhogadoSmashy03.jpg"
import ahogadoSmashy04 from "assets/img/activities/AhogadoSmashy04.jpg"
import ahogadoSmashor00 from "assets/img/activities/AhogadoSmashor00.jpg"
import ahogadoSmashor01 from "assets/img/activities/AhogadoSmashor01.jpg"
import ahogadoSmashor02 from "assets/img/activities/AhogadoSmashor02.jpg"
import ahogadoSmashor03 from "assets/img/activities/AhogadoSmashor03.jpg"
import ahogadoSmashor04 from "assets/img/activities/AhogadoSmashor04.jpg"
import edit from "assets/img/activities/edit.png"
import heardIcon from "assets/img/activities/heard_icon.png"
import notesLeftSticker from "assets/img/activities/stick_left.png"
import notesRightSticker from "assets/img/activities/stick_right.png"
import notesBg from "assets/img/activities/squere_bg.png"
import notesBgDark from "assets/img/activities/squere_bg_dark.png"
import titleLine from "assets/img/activities/sub.png"
import mediaBg from "assets/img/activities/FondoCuadros.png"
import maximize from "assets/img/activities/maximize.png"
import minimize from "assets/img/activities/minimize.png"
import content from "assets/img/tools/content.png"
import glitch from "assets/img/tools/glitch.png"
import messages from "assets/img/tools/messages.png"
import faq from "assets/img/tools/faq.png"
import library from "assets/img/tools/books-min.png"
import gameIcon from "assets/img/tools/game-min.png"
import gameIconActive from "assets/img/tools/game2-min.png"
import targetIcon from "assets/img/tools/blanco-min.png"
import targetIconActive from "assets/img/tools/blanco2-min.png"
import searchIcon from "assets/img/tools/buscar-min.png"
import searchIconActive from "assets/img/tools/buscar2-min.png"
import notes from "assets/img/tools/notes-min.png"
import notesTool from "assets/img/tools/notes.png"
import pictures from "assets/img/tools/pictures.png"
import darkMode from "assets/img/tools/dark-mode.png"
import selectDarkMode from "assets/img/tools/select-dark-mode.png"
import selectLightMode from "assets/img/tools/select-light-mode.png"
import doc from "assets/img/activities/doc.png"
import cardTypes from "assets/img/games/slot/card-types.png"
import pairsTypes from "assets/img/games/slot/pairs-type.png"
import soundTypes from "assets/img/games/slot/sound-types.png"
import memoramaIcon from "assets/img/tools/memorama_sm_2.png"
import memoramaIconActive from "assets/img/tools/memorama_sm_2_empty.png"
import gameMemorama from "assets/img/games/memorama-g-min.png"
import gameMemoramaActive from "assets/img/games/memorama-min.png"
import gameWordSearch from "assets/img/games/sopa letras-g-min.png"
import gameWordSearchActive from "assets/img/games/sopa letras-min.png"
import gameWordcross from "assets/img/games/crucugrama-g-min.png"
import gameWordcrossActive from "assets/img/games/crucugrama-min.png"
import gameSmash from "assets/img/games/smash g-min.png"
import gameSmashActive from "assets/img/games/smash-min.png"
import games from "assets/img/games/games.png"
import gameWordsMaze from "assets/img/games/words-maze-gris.png"
import gameWordsMazeActive from "assets/img/games/words-maze-naranja.png"
import getStarted1 from "assets/img/getStarted/Imagen1.gif"
import getStarted2 from "assets/img/getStarted/Imagen2.gif"
import getStarted8 from "assets/img/getStarted/Imagen3.gif"
import getStarted3 from "assets/img/getStarted/Imagen4.gif"
import getStarted4 from "assets/img/getStarted/Imagen5.gif"
import getStarted5 from "assets/img/getStarted/Imagen7.gif"
import getStarted6 from "assets/img/getStarted/Imagen8.gif"
import getStarted7 from "assets/img/getStarted/Imagen9.gif"
import headset from "assets/img/getStarted/headset.png"
import microphone from "assets/img/getStarted/microphone.png"
import moduleExpired from "assets/img/common/student_s.png"
import userIndividual from "assets/img/games/smash-game-individual.png"
import userVersus from "assets/img/games/smash-games-versus.png"
import explanationBg from "assets/img/activities/explanation_bg.jpg"
import teamwork from "assets/img/common/teamwork.png"
import printer from "assets/img/common/printer.png"
import logo from "assets/img/app/logo/logo.png"
import logoA from "assets/img/app/logo/logo-a.png"
import logoAppBar from "assets/img/app/logo/logo-navbar-a.svg"
import idea from "assets/img/common/idea.png"
import language from "assets/img/common/language.png"
import language2 from "assets/img/common/language-2.png"
import gloveIcon from "assets/img/games/boxing_one_icon.png"
import bullseyeIcon from "assets/img/games/bullseye_arrow_icon.png"
import medalBadge from "assets/img/games/medal_badge.png"
import logoMini from "assets/img/app/logo/logo-mini.png"
import transparency from "assets/img/common/transparency.png"
import qrCode from "assets/img/common/qr-code-lector.png"
import membershipBg1 from "assets/img/memberships/pricing_1.png"
import membershipBg2 from "assets/img/memberships/pricing_2.png"
import membershipBg3 from "assets/img/memberships/pricing_3.png"
import calendarIcon from "assets/img/missions/calendar.png"
import message from "assets/img/common/MessagesOff.png"
import ipad from "assets/img/common/ipad.png"
import codeComputer from "assets/img/common/code.png"
import picture from "assets/img/common/picture.png"
import fontDyslexicOn from "assets/img/activities/dislexia-on-min.png"
import fontDyslexicOff from "assets/img/activities/dislexia-off-min.png"
import lectureOn from "assets/img/activities/lecture-on.png"
import lectureOff from "assets/img/activities/lecture-off.png"
import diplomaFrame from "assets/img/rewards/frame.png"
import diplomaFrame2 from "assets/img/rewards/frame-02.png"
import smashMedal from "assets/img/rewards/medal.png"
import decor1 from "assets/img/rewards/decor01.png"
import decor2 from "assets/img/rewards/decor02.png"
import decor3 from "assets/img/rewards/decor03.png"
import decor4 from "assets/img/rewards/decor04.png"
import decor5 from "assets/img/rewards/decor05.png"
import decor6 from "assets/img/rewards/decor06.png"
import decor7 from "assets/img/rewards/decor07.png"
import decor8 from "assets/img/rewards/decor08.png"
import decor9 from "assets/img/rewards/decor09.png"
import decor10 from "assets/img/rewards/decor10.png"
import decor11 from "assets/img/rewards/decor11.png"
import decor12 from "assets/img/rewards/decor12.png"
import logo2 from "assets/img/app/logo/logo-2.png"
import skippedModule from "assets/img/common/skipped-module.png"
import chatOn from "assets/img/app/chat_on.png"
import chatOff from "assets/img/app/chat_off.png"
import quickbooksLogo from "assets/img/common/intuit_quickbooks_logo.png"
import demoTeam from "assets/img/demo-team.png"
import readalone from "assets/img/common/read_alone.png"
import readtogether from "assets/img/common/read_together.png"
import studentBg from "assets/img/app/student-bg.png"
import studentBgCuadrado from "assets/img/app/student-bg-cuadraro.png"
import studentBgMobile from "assets/img/app/student-bg-mobile.png"
import loginEnterCode from "assets/img/auth/login/enter-code.png"
import loginLoved from "assets/img/auth/login/loved.png"
import loginPassword from "assets/img/auth/login/password.png"
import loginQrCuadrado from "assets/img/auth/login/qr-cuadrado.png"
import loginSafeAndSecure from "assets/img/auth/login/safe-and-secure.png"
import loginTrusted from "assets/img/auth/login/trusted.png"
import loginUser from "assets/img/auth/login/user.png"
import loginViewPassword from "assets/img/auth/login/view-password.png"
import loginSmashy from "assets/img/auth/login/smashy.gif"
import loginPop from "assets/img/auth/login/pop.png"
import forgotPaasswordSmashor from "assets/img/auth/forgotPassword/profesor.gif"
import forgotPasswordEmail from "assets/img/auth/forgotPassword/email.png"
import forgotPasswordPack from "assets/img/auth/forgotPassword/pack.png"
import forgotPasswordTeacher from "assets/img/auth/forgotPassword/password-teacher.png"
import forgotPasswordSend from "assets/img/auth/forgotPassword/send.png"
import forgotPasswordStudent from "assets/img/auth/forgotPassword/student.png"
import forgotPasswordProfesor2 from "assets/img/auth/forgotPassword/profesor2.gif"
import forgotPasswordProfesor3 from "assets/img/auth/forgotPassword/profesor3.gif"
import scanQRgris from "assets/img/auth/scanQRCode/QRgris.png"
import scanQRcamara from "assets/img/auth/scanQRCode/camara.png"
import scanQRcircular from "assets/img/auth/scanQRCode/circular.png"
import scanQRfolder from "assets/img/auth/scanQRCode/folder.png"
import scanQRquestion from "assets/img/auth/scanQRCode/question.png"
import scanQRsmashyGif from "assets/img/auth/scanQRCode/smashy.gif"
import classCodeSmashy from "assets/img/auth/classCode/smashy.gif"
import classCodeClass from "assets/img/auth/classCode/class.png"
import classCodeQrCuadrado from "assets/img/auth/classCode/QRcuadrado.png"
import selectUserGroup from "assets/img/auth/selectUser/group.png"
import selectUserHelp from "assets/img/auth/selectUser/help.png"
import selectUserSearch from "assets/img/auth/selectUser/search.png"
import accountTicketPrincipal from "assets/img/auth/account/ticketPrincipal.png"
import accountTicketGris from "assets/img/auth/account/ticketGris.png"
import target from "assets/img/common/target.png"
import spanishFlag from "assets/img/flags/spanishx32.png"
import englishFlag from "assets/img/flags/englishx32.png"
import frenchFlag from "assets/img/flags/frenchx32.png"
import canadaFlag from "assets/img/flags/canadax32.png"
import checkCircle from "assets/img/professor/groups/setup/check-circle.png"
import iconUsers from "assets/img/professor/groups/setup/icon-users.png"
import iconInfo from "assets/img/professor/groups/setup/icon-info.png"
import iconIdea from "assets/img/professor/groups/setup/icon-idea.png"
import iconSecurity from "assets/img/professor/groups/setup/icon-security.png"
import smashyCongrats from "assets/img/auth/smashy-congrats.gif"
import smashorCongrats from "assets/img/auth/smashor-congrats.gif"
import rocketIcon from "assets/img/auth/account/rocket.png"
import teacherClassroomElementary from "assets/img/professor/groups/setup/teacher-classroom-1.png"
import independentLearningElementary from "assets/img/professor/groups/setup/independent-learning-1.png"
import teacherClassroomSecondary from "assets/img/professor/groups/setup/teacher-classroom-2.png"
import independentLearningSecondary from "assets/img/professor/groups/setup/independent-learning-2.png"
import teacherClassroomHigherEducation from "assets/img/professor/groups/setup/teacher-classroom-3.png"
import independentLearningHigherEducation from "assets/img/professor/groups/setup/independent-learning-3.png"
import pedagogicalStepAddStudents from "assets/img/professor/groups/pedagogical/addStudents.png"
import pedagogicalStepAssignContent from "assets/img/professor/groups/pedagogical/assignContent.png"
import pedagogicalStepContinuePlacementTest from "assets/img/professor/groups/pedagogical/continuePlacementTest.png"
import pedagogicalStepGradeXactivities from "assets/img/professor/groups/pedagogical/gradeXactivities.png"
import pedagogicalStepNoActiveMissions from "assets/img/professor/groups/pedagogical/noActiveMissions.png"
import pedagogicalStepNoStudents from "assets/img/professor/groups/pedagogical/noStudents.png"
import pedagogicalStepNone from "assets/img/professor/groups/pedagogical/none.png"
import pedagogicalStepPlacementTestComplete from "assets/img/professor/groups/pedagogical/placementTestComplete.png"
import pedagogicalStepPlacementTestInProgress from "assets/img/professor/groups/pedagogical/placementTestInProgress.png"
import pedagogicalStepPlacementTestNotStarted from "assets/img/professor/groups/pedagogical/placementTestNotStarted.png"
import pedagogicalStepReviewPlacementTestResults from "assets/img/professor/groups/pedagogical/reviewPlacementTestResults.png"
import pedagogicalStepRunPlacementTest from "assets/img/professor/groups/pedagogical/runPlacementTest.png"
import pedagogicalStepXMissionsOpen from "assets/img/professor/groups/pedagogical/xMissionsOpen.png"
import pedagogicalStepCreateSubGroups from "assets/img/professor/groups/pedagogical/createSubGroups.png"
import pedagogicalStepNoSubGroups from "assets/img/professor/groups/pedagogical/noSubGroups.png"

export const images = {
  spanishFlag,
  englishFlag,
  frenchFlag,
  canadaFlag,
  studentBgMobile,
  studentBgCuadrado,
  studentBg,
  target,
  readalone,
  readtogether,
  demoTeam,
  quickbooksLogo,
  "chat-on": chatOn,
  "chat-off": chatOff,
  skippedModule,
  logo2,
  diplomaFrame,
  diplomaFrame2,
  smashMedal,
  darkMode,
  selectDarkMode,
  selectLightMode,
  "lecture-on": lectureOn,
  "lecture-off": lectureOff,
  "font-dyslexic-on": fontDyslexicOn,
  "font-dyslexic-off": fontDyslexicOff,
  picture,
  codeComputer,
  ipad,
  message,
  calendar: calendarIcon,
  qrCode,
  medalBadge,
  logoMini,
  logoA,
  logoAppBar,
  gloveIcon,
  bullseyeIcon,
  printer,
  teamwork,
  cardTypes,
  pairsTypes,
  soundTypes,
  listeningIcon,
  readingIcon,
  speakingIcon,
  writingIcon,
  checkIcon,
  wrongIcon,
  correctAnswer,
  wrongAnswer,
  ahogado01,
  ahogado02,
  ahogado03,
  ahogado04,
  ahogado05,
  ahogadoSmashy01,
  ahogadoSmashy02,
  ahogadoSmashy03,
  ahogadoSmashy04,
  ahogadoSmashy00,
  ahogadoSmashor01,
  ahogadoSmashor02,
  ahogadoSmashor03,
  ahogadoSmashor04,
  ahogadoSmashor00,
  edit,
  heardIcon,
  notesLeftSticker,
  notesRightSticker,
  notesBg,
  notesBgDark,
  titleLine,
  mediaBg,
  maximize,
  minimize,
  content,
  glitch,
  library,
  gameIcon,
  gameIconActive,
  targetIcon,
  targetIconActive,
  searchIcon,
  searchIconActive,
  notes,
  notesTool,
  pictures,
  doc,
  memoramaIcon,
  memoramaIconActive,
  games,
  gameMemorama,
  gameMemoramaActive,
  gameWordSearch,
  gameWordSearchActive,
  gameWordcross,
  gameWordcrossActive,
  gameSmash,
  gameSmashActive,
  gameWordsMaze,
  gameWordsMazeActive,
  headset,
  microphone,
  moduleExpired,
  userIndividual,
  userVersus,
  userIndividualActive: userIndividual,
  userVersusActive: userVersus,
  explanationBg,
  messages,
  faq,
  logo,
  idea,
  language,
  language2,
  transparency,
  checkCircle,
  iconUsers,
  iconInfo,
  iconIdea,
  iconSecurity,
  smashyCongrats,
  smashorCongrats,
  rocketIcon,
  teacherClassroomElementary,
  independentLearningElementary,
  teacherClassroomSecondary,
  independentLearningSecondary,
  teacherClassroomHigherEducation,
  independentLearningHigherEducation,
}

export const activitiesImages = {
  fr_FR: {
    headphones: "headphones.png",
    DA: "DA.png",
    WD: "WD.png",
    P: "P.png",
    send: "send.mp4",
    pronounce: "pronounce.mp4",
    pronounce2: "Pronounce-preuba3.gif",
    skip: "skip.png",
    strike: "strike.gif",
    MODULE_END: "end.gif",
    WD_2: "WD.gif",
    enable_microphone: "enable_microphone.png",
    teamWork: {
      1: "1-min.jpg",
      2: "2-min.jpg",
      3: "3-min.jpg",
      4: "4-min.jpg",
      5: "5-min.jpg",
      6: "6-min.jpg",
      7: "7-min.jpg",
      8: "8-min.jpg",
      9: "9-min.jpg",
      10: "10-min.jpg",
    },
  },
  en_US: {
    headphones: "headphones.png",
    DA: "DA.png",
    WD: "WD.png",
    P: "P.png",
    send: "send.mp4",
    pronounce: "pronounce.mp4",
    pronounce2: "Pronounce-preuba3.gif",
    skip: "skip.png",
    strike: "strike.gif",
    MODULE_END: "end.gif",
    WD_2: "WD.gif",
    enable_microphone: "enable_microphone.png",
    teamWork: {
      1: "1-min.jpg",
      2: "2-min.jpg",
      3: "3-min.jpg",
      4: "4-min.jpg",
      5: "5-min.jpg",
      6: "6-min.jpg",
      7: "7-min.jpg",
      8: "8-min.jpg",
      9: "9-min.jpg",
      10: "10-min.jpg",
    },
  },
  es_MX: {
    headphones: "headphones.png",
    DA: "DA.png",
    WD: "WD.png",
    P: "P.png",
    send: "send.mp4",
    pronounce: "pronounce.mp4",
    pronounce2: "Pronounce-preuba3.gif",
    skip: "skip.png",
    strike: "strike.gif",
    MODULE_END: "end.gif",
    WD_2: "WD.gif",
    enable_microphone: "enable_microphone.png",
    teamWork: {
      1: "1-min.jpg",
      2: "2-min.jpg",
      3: "3-min.jpg",
      4: "4-min.jpg",
      5: "5-min.jpg",
      6: "6-min.jpg",
      7: "7-min.jpg",
      8: "8-min.jpg",
      9: "9-min.jpg",
      10: "10-min.jpg",
    },
  },
  ar: {
    // Arabic
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  bg: {
    // Bulgarian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  bn: {
    // Bengali
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  cs: {
    // Czech
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  da: {
    // Danish
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  de: {
    // German
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  el: {
    // Greek
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  et: {
    // Estonian
    DA: "da-png.gif",
    WD: "wd-png.gif",
    P: "p-png.gif",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  fa: {
    // Farsi
    DA: "da-png.gif",
    WD: "wd-png.gif",
    P: "p-png.gif",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  fi: {
    // Finnish
    DA: "da-png.gif",
    WD: "wd-png.gif",
    P: "p-png.gif",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  gu: {
    // Gujarati
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  hi: {
    // Hindi
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  hu: {
    // Hungarian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  id: {
    // Indonesian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  it: {
    // Italian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ja: {
    // Japanese
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ko: {
    // Korean
    DA: "da-png.gif",
    WD: "wd-png.gif",
    P: "p-png.gif",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ku: {
    // Kurdish
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  lt: {
    // Lithuanian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  lv: {
    // Latvian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  nl: {
    // Dutch
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  no: {
    // Norwegian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  pa: {
    // Punjabi
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  pl: {
    // Polish
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ps: {
    // Pashto
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  pt: {
    // Portuguese
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  pt_BR: {
    // Portuguese (Brazil)
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ro: {
    // Romanian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ru: {
    // Russian
    DA: "da-png.gif",
    WD: "wd-png.gif",
    P: "p-png.gif",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  sk: {
    // Slovak
    DA: "da-png.gif",
    WD: "wd-png.gif",
    P: "p-png.gif",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  sl: {
    // Slovenian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  so: {
    // Somali
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  sv: {
    // Swedish
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ta: {
    // Tamil
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  te: {
    // Telugu
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  fil: {
    // Tagalog
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  tr: {
    // Turkish
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  uk: {
    // Ukrainian
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  ur: {
    // Urdu
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  vi: {
    // Vietnamese
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  zh_HK: {
    // Yue Cantonese
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  zh_CN: {
    // Chinese (Simplified)
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
  zh_Hans: {
    // Chinese (Simplified)
    DA: "da.png",
    WD: "wd.png",
    P: "p.png",
    MODULE_END: "end.gif",
    WD_2: "wd.gif",
    teamWork: {
      1: "1.jpg",
      2: "2.jpg",
      3: "3.jpg",
      4: "4.jpg",
      5: "5.jpg",
      6: "6.jpg",
      7: "7.jpg",
      8: "8.jpg",
      9: "9.jpg",
      10: "10.jpg",
    },
  },
}

const mainFolder = "https://login.smasheducation.com/tutorialAssets/animations/"

export const getStarted = {
  getStarted1,
  getStarted2,
  getStarted3,
  getStarted4,
  getStarted5,
  getStarted6,
  getStarted7,
  getStarted8,
  es: {
    6: `${mainFolder}/es/6.gif`,
    10: `${mainFolder}/es/10.gif`,
    11: `${mainFolder}/es/11.gif`,
    15: `${mainFolder}/es/15.gif`,
    17: `${mainFolder}/es/17.gif`,
    getStarted1: require("assets/img/getStarted/es/Imagen1.gif"),
    getStarted2: require("assets/img/getStarted/es/Imagen2.gif"),
    getStarted3: require("assets/img/getStarted/es/Imagen3.gif"),
    getStarted4: require("assets/img/getStarted/es/Imagen4.gif"),
    getStarted5: require("assets/img/getStarted/es/Imagen5.gif"),
    getStarted6: require("assets/img/getStarted/es/Imagen7.gif"),
    getStarted7: require("assets/img/getStarted/es/Imagen8.gif"),
    getStarted8: require("assets/img/getStarted/es/Imagen9.gif"),
  },
  en: {
    6: `${mainFolder}/en/6.gif`,
    10: `${mainFolder}/en/10.gif`,
    11: `${mainFolder}/en/11.gif`,
    15: `${mainFolder}/en/15.gif`,
    17: `${mainFolder}/en/17.gif`,
    getStarted1: require("assets/img/getStarted/en/Imagen1.gif"),
    getStarted2: require("assets/img/getStarted/en/Imagen2.gif"),
    getStarted3: require("assets/img/getStarted/en/Imagen3.gif"),
    getStarted4: require("assets/img/getStarted/en/Imagen4.gif"),
    getStarted5: require("assets/img/getStarted/en/Imagen5.gif"),
    getStarted6: require("assets/img/getStarted/en/Imagen7.gif"),
    getStarted7: require("assets/img/getStarted/en/Imagen8.gif"),
    getStarted8: require("assets/img/getStarted/en/Imagen9.gif"),
  },
  fr: {
    6: `${mainFolder}/fr/6.gif`,
    10: `${mainFolder}/fr/10.gif`,
    11: `${mainFolder}/fr/11.gif`,
    15: `${mainFolder}/fr/15.gif`,
    17: `${mainFolder}/fr/17.gif`,
    getStarted1: require("assets/img/getStarted/fr/Imagen1.gif"),
    getStarted2: require("assets/img/getStarted/fr/Imagen2.gif"),
    getStarted3: require("assets/img/getStarted/fr/Imagen3.gif"),
    getStarted4: require("assets/img/getStarted/fr/Imagen4.gif"),
    getStarted5: require("assets/img/getStarted/fr/Imagen5.gif"),
    getStarted6: require("assets/img/getStarted/fr/Imagen7.gif"),
    getStarted7: require("assets/img/getStarted/fr/Imagen8.gif"),
    getStarted8: require("assets/img/getStarted/fr/Imagen9.gif"),
  },
}

export const getStartedPng = {
  es: {
    6: `${mainFolder}/es/6.png`,
    10: `${mainFolder}/es/10.png`,
    11: `${mainFolder}/es/11.png`,
    15: `${mainFolder}/es/15.png`,
    17: `${mainFolder}/es/17.png`,
  },
  en: {
    6: `${mainFolder}/en/6.png`,
    10: `${mainFolder}/en/10.png`,
    11: `${mainFolder}/en/11.png`,
    15: `${mainFolder}/en/15.png`,
    17: `${mainFolder}/en/17.png`,
  },
  fr: {
    6: `${mainFolder}/fr/6.png`,
    10: `${mainFolder}/fr/10.png`,
    11: `${mainFolder}/fr/11.png`,
    15: `${mainFolder}/fr/15.png`,
    17: `${mainFolder}/fr/17.png`,
  },
}

export const membershipsBg = {
  1: membershipBg1,
  2: membershipBg2,
  3: membershipBg3,
}

export const diplomasBg = {
  1: decor1,
  2: decor2,
  3: decor3,
  4: decor4,
  5: decor5,
  6: decor6,
  7: decor7,
  8: decor8,
  9: decor9,
  10: decor10,
  11: decor11,
  12: decor12,
}

export const fontsImages = {
  Poppins: require("assets/img/fonts/Popins.png"),
  OpenDyslexic: require("assets/img/fonts/Dyslexia.png"),
  EduFundation: require("assets/img/fonts/Edu_Fundation.png"),
  GochiHand: require("assets/img/fonts/Gochi_Hand.png"),
  McLaren: require("assets/img/fonts/McLaren.png"),
  PatrickHand: require("assets/img/fonts/Patrick_Hand.png"),
  PlaypenSans: require("assets/img/fonts/Playpen_Sans.png"),
  PoiretOne: require("assets/img/fonts/Poiret_One.png"),
  Quicksand: require("assets/img/fonts/Quicksand.png"),
}

export const fontImagesBW = {
  Poppins: require("assets/img/fonts/Popins_g.png"),
  OpenDyslexic: require("assets/img/fonts/Dyslexia_g.png"),
  EduFundation: require("assets/img/fonts/Edu_Fundation_g.png"),
  GochiHand: require("assets/img/fonts/Gochi_Hand_g.png"),
  McLaren: require("assets/img/fonts/McLaren_g.png"),
  PatrickHand: require("assets/img/fonts/Patrick_Hand_g.png"),
  PlaypenSans: require("assets/img/fonts/Playpen_Sans_g.png"),
  PoiretOne: require("assets/img/fonts/Poiret_One_g.png"),
  Quicksand: require("assets/img/fonts/Quicksand_g.png"),
}

export const loginImages = {
  authBg: studentBg,
  authBgCuadrado: studentBgCuadrado,
  authBgMobile: studentBgMobile,
  enterCode: loginEnterCode,
  loved: loginLoved,
  password: loginPassword,
  qrCuadrado: loginQrCuadrado,
  safeAndSecure: loginSafeAndSecure,
  trusted: loginTrusted,
  user: loginUser,
  viewPassword: loginViewPassword,
  smashy: loginSmashy,
  pop: loginPop,
}

export const forgotPasswordImages = {
  profesor: forgotPaasswordSmashor,
  email: forgotPasswordEmail,
  pack: forgotPasswordPack,
  teacher: forgotPasswordTeacher,
  send: forgotPasswordSend,
  student: forgotPasswordStudent,
  profesor2: forgotPasswordProfesor2,
  profesor3: forgotPasswordProfesor3,
}

export const scanQRCodeImages = {
  QRgris: scanQRgris,
  camara: scanQRcamara,
  circular: scanQRcircular,
  folder: scanQRfolder,
  question: scanQRquestion,
  smashyGif: scanQRsmashyGif,
}

export const classCodeImages = {
  smashy: classCodeSmashy,
  enterCode: classCodeClass,
  qrIcon: classCodeQrCuadrado,
}

export const selectUserImages = {
  group: selectUserGroup,
  help: selectUserHelp,
  search: selectUserSearch,
}

export const accountImages = {
  ticketPrincipal: accountTicketPrincipal,
  ticketGris: accountTicketGris,
}

export const getClassTypeImages = (gradeId) => {
  if ([1, 2, 3, 4, 5, 6].includes(gradeId)) {
    return {
      teacherLed: images.teacherClassroomElementary,
      independent: images.independentLearningElementary,
    }
  }

  if (gradeId === 13) {
    return {
      teacherLed: images.teacherClassroomHigherEducation,
      independent: images.independentLearningHigherEducation,
    }
  }

  return {
    teacherLed: images.teacherClassroomSecondary,
    independent: images.independentLearningSecondary,
  }
}

export const PEDAGOGICAL_STATUS_IMAGE_BY_TYPE = {
  AddStudents: pedagogicalStepAddStudents,
  RunPlacementTest: pedagogicalStepRunPlacementTest,
  ContinuePlacementTest: pedagogicalStepContinuePlacementTest,
  ReviewPlacementTestResults: pedagogicalStepReviewPlacementTestResults,
  AssignContent: pedagogicalStepAssignContent,
  GradeTeacherActivities: pedagogicalStepGradeXactivities,
  NoSegments: pedagogicalStepCreateSubGroups,
}

export const PEDAGOGICAL_DESCRIPTION_IMAGE_BY_TYPE = {
  AddStudents: pedagogicalStepNoStudents,
  RunPlacementTest: pedagogicalStepPlacementTestNotStarted,
  ContinuePlacementTest: pedagogicalStepPlacementTestInProgress,
  ReviewPlacementTestResults: pedagogicalStepPlacementTestComplete,
  AssignContent: pedagogicalStepNoActiveMissions,
  GradeTeacherActivities: pedagogicalStepXMissionsOpen,
  NoSegments: pedagogicalStepNoSubGroups,
}

export const getPedagogicalStatusImage = (type) =>
  PEDAGOGICAL_STATUS_IMAGE_BY_TYPE[type] || pedagogicalStepNone

export const getPedagogicalDescriptionImage = (type) =>
  PEDAGOGICAL_DESCRIPTION_IMAGE_BY_TYPE[type] || pedagogicalStepNoActiveMissions
